import React from 'react'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Tooltip from '@mui/material/Tooltip'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutlined'
import { useTranslation } from 'react-i18next'
import { AdvisorWithEventualId } from './types'

export function AdvisorList({
    advisors,
    onDelete,
}: {
    advisors: Array<AdvisorWithEventualId>
    onDelete: (a: AdvisorWithEventualId) => void
}) {
    const { t } = useTranslation()
    return (
        <List>
            {advisors
                .sort((a, b) => a?.name.localeCompare(b.name) || 0)
                .map((advisor) => (
                    <ListItem key={`${advisor.advisorId}:${advisor.name}`}>
                        <Tooltip title={t('site.actions.delete')}>
                            <IconButton size='small' onClick={() => onDelete(advisor)}>
                                <RemoveCircleOutlineIcon fontSize='inherit' />
                            </IconButton>
                        </Tooltip>
                        <ListItemText primary={advisor.name} />
                    </ListItem>
                ))}
        </List>
    )
}
